import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import MuiInput from '@mui/material/Input';
import React from 'react';

const Input = styled(MuiInput)`
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #C1C7CD;
  border-radius: 8px;

  &::before {
    border: none;
  }

  &::after {
    border: none;
  }

    

`;

export default function NumberSlider({ value, setValue, label, range, }: {
    value: number,
    setValue: React.Dispatch<React.SetStateAction<number | null>> | React.Dispatch<React.SetStateAction<number>>,
    label: string,
    range: {
      min: number,
      max: number,
      step: number,
    }
}) {

    const handleSliderChange = (event: Event, newValue: number | number[]) => {
        setValue(newValue as number);
      };
    
      const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value === '' ? 0 : Number(event.target.value));
      };
    
      const handleBlur = () => {
        if (value < range.min) {
            setValue(range.min);
        } else if (value > range.max) {
            setValue(range.max);
        }
      };


    return (
        <div className="w-full flex flex-col gap-2 justify-start items-start">
            <label className="font-medium text-[12px] text-default flex justify-start items-center gap-2">{label}</label>
            <Input
                value={value}
                sx={{
                    fontFamily: 'Montserrat',
                    fontWeight: 400,
                    '& .MuiInputBase-input': {
                        padding: 0,
                    },
                    "&:hover:not(.Mui-disabled, .Mui-error):before": {
                    borderBottom: "none !important", // Removes the black border on hover
                    },
                }}
                size="small"
                onChange={handleInputChange}
                onBlur={handleBlur}
                inputProps={{
                step: range.step,
                min: range.min,
                max: range.max,
                type: 'number',
                'aria-labelledby': 'input-slider',
                }}
            />
            <Slider
                value={typeof value === 'number' ? value : 0}
                onChange={handleSliderChange}
                step={range.step}
                min={range.min}
                max={range.max}
                aria-labelledby="input-slider"
                sx={{
                    color: '#0C848F',
                }}
                size='small'
            />
        </div>
    )
}